<template>
    <div class="wrap-layer">
        <div class="top-logo">
            <img src="@/assets/images/login/logo-dark.png" class="login-logo" alt="" ondragstart="return false" />
            <div>电子合同服务平台</div>
        </div>
        <div class="cart-body auto">
            <div class="head">
                文件校验
            </div>
            <div class="info">
                <div>
                    <div class="check-title">检测电子文件签名是否被篡改，文件是否真实有效</div>
                    <div>
                        <el-upload ref="fileId" drag :action="uploadUrl" name="file" :on-success="uploadSuccess"
                            :before-upload="beforeUpload" :on-exceed="handleExceed" :limit="1" :auto-upload="true"
                            :on-remove="removeDoc">
                            <div></div>
                            <img src="../../assets/images/pdf-icon.png" alt="">
                            <div class="el-upload__text">将电子签约文件拖动至此，或<em>点击上传</em>PDF文件</div>
                            <div slot="tip" class="el-upload__tip">说明：只能上传PDF文件，且大小不超过50MB
                            </div>
                            <div slot="tip" class="el-upload__tip" style="color: #ff0000">{{ tips }}</div>
                        </el-upload>
                    </div>
                    <div class="check-advant">
                        <div v-for="(item, idx) in advants" :key="idx" class="check-advant-item">
                            <span class="dot"></span>
                            <span class="check-advant-text">{{ item }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cart-body auto file-check-wrap" v-if="checkFile.check">
            <div class="file-name">{{ checkFile.fileName }}</div>
            <div>
                <div class="file-check-length">文件中共有<span>{{ checkFile.length }}</span>个签名</div>
            </div>
            <div class="file-check-result" v-for="(item, idx) in checkFile.checkList" :key="idx">
                <div class="layer1">
                    <img src="../../assets/images/tick.png" alt="" class="tick-icon" v-if="item.res">
                    <span class="signer">由“{{ item.subjectDnCN }}”签名</span>
                </div>
                <div class="layer">
                    <div class="label">签名有效：</div> 自应用本签名以来，文档未被修改
                </div>
                <div class="layer">
                    <div class="label">签署平台：</div> 正元签电子合同服务平台
                </div>
                <div class="layer">
                    <div class="label">签名时间：</div> {{ item.time }}
                </div>
                <div class="layer">
                    <div class="label">电子签名：</div>
                    <el-image class="seal-pic" :src="item.imgBase64" alt="" :preview-src-list="[item.imgBase64]">
                    </el-image>
                </div>
                <div class="layer">
                    <div class="label">证书信息：</div>
                    <div>
                        <div class="sub-layer">证书颁发机构：&nbsp;{{ item.issuerDnCN }}</div>
                        <div class="sub-layer">证书有效期：&nbsp;{{ item.notBefore }}&nbsp;至&nbsp;{{ item.notAfter }}</div>
                        <div class="sub-layer">证书用途：&nbsp;数字签名，不可否认，加密密钥，加密文档</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { pdfVerifyAddressPath } from '@/api/check/report'

function getParameterByName(name, str) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?,]" + name + "(=([^,#]*)|,|#|$)"),
        results = regex.exec(str);
    if (!results) return null;
    if (!results[2]) return '';
    return results[2].replace(/\+/g, " ");
}

export default {
    data() {
        return {
            // uploadUrl: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + 'api/common/v1/reoprt/pdfVerify',
            uploadUrl: pdfVerifyAddressPath,
            advants: ["支持验证文件是否有被篡改", "支持验证文件是否有签名", "支持验证文件签名时间", "支持验证文件签名是否有效", "支持验证文件签名者信息"],
            tips: "",
            checkFile: {
                check: false,
                fileName: "",
                length: "",
                checkList: []
            }
        };
    },
    created() {
    },
    mounted() { },
    methods: {
        beforeUpload(file) {
            if (file.size > 50 * 1024 * 1024) {
                this.msgError("只允许上传50M以内的文件");
                return false
            }
            if (file.name.substr(file.name.lastIndexOf(".")) != ".pdf") {
                this.msgError("文件格式错误，仅支持pdf模板");
                return false
            }
            this.tips = '文件较大时上传及处理时间可能会较长，请耐心等待直至本提示消失......'
            // this.submitDisable = true
            return true
        },
        uploadSuccess(res, file, fileList) {
            if (res.code != 200) {
                this.tips = res.message;
                this.$forceUpdate();
            } else {
                this.msgSuccess("上传成功");
                this.tips = '';
                this.checkFile.check = true;
                this.checkFile.fileName = file.name;
                this.checkFile.length = res.data.infoList.length;
                res.data.infoList.map(item => {
                    item.subjectDnCN = getParameterByName("CN", item.subjectDn);
                    item.issuerDnCN = getParameterByName("CN", item.issuerDn);
                })
                this.checkFile.checkList = res.data.infoList;
            }
        },
        handleExceed(files, fileList) {
            if (fileList.length >= 1) {
                this.msgError("只允许上传一个文件");
            }
        },
        removeDoc(file, fileList) {
            this.tips = "";
            this.checkFile = {
                check: false,
                fileName: "",
                length: "",
                checkList: []
            }
        },
    }
};
</script>
<style lang="scss" scoped>
.top-logo {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9;
    padding: 28px 52px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 400;
    color: #292d40;

    img {
        display: block;
        width: 90px;
        height: auto;
        margin-right: 19px;
    }
}

.wrap-layer {
    background: #f0f0f5;
    min-height: 100vh;
    padding-top: 90px;
    background: url("../../assets/images/login/login-bg.png") repeat;
    background-size: 100%;

    .cart-body {
        background: #fff;
        padding: 27px 30px;
        position: relative;
        box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.13);

        &+.cart-body {
            margin-top: 34px;
        }

        .head {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            border-left: 3px solid #3296fa;
            height: 20px;
            line-height: 20px;
            padding-left: 14px;
        }

        /deep/ .el-upload {
            width: 590px;
            height: 300px;

            .el-upload-dragger {
                width: 590px;
                height: 300px;
                padding: 23px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;

                img {
                    width: 41px;
                    height: auto;
                    display: block;
                }
            }
        }

        .info {
            width: 590px;
            margin: 0 auto;
            text-align: center;
            padding-bottom: 36px;

            .check-title {
                font-size: 16px;
                font-weight: 400;
                color: #333333;
                margin-bottom: 14px;
                margin-top: 56px;
            }

            .check-advant {
                display: grid;
                grid-gap: 18px 52px;
                grid-template-columns: repeat(auto-fit, minmax(162px, 0));
                margin-top: 30px;

                .check-advant-item {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .dot {
                        width: 4px;
                        height: 4px;
                        background: #9299A5;
                        border-radius: 50%;
                        margin-right: 8px;
                    }

                    .check-advant-text {
                        font-size: 12px;
                        font-weight: 400;
                        color: #9299A5;
                    }
                }

            }

            .cell {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 14px;
                color: #333;
                line-height: 35px;

                .label {
                    width: 150px;
                }

                .big {
                    color: #3296fa;
                    font-size: 16px;
                    font-weight: bold;
                }
            }


        }


    }

    .file-check-wrap {
        padding: 35px 98px 70px;

        .file-name {
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            text-align: center;
            margin-bottom: 18px;
        }

        .file-check-result {
            width: 100%;
            background: #FBFDFF;
            border: 1px solid #DCDEE2;
            padding: 20px;

            .tick-icon {
                width: 20px;

            }

            .signer {
                font-size: 16px;
                font-weight: bold;
                color: #000000;
                margin-left: 8px;
            }

            .layer1 {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-bottom: 20px;
            }

            .layer {
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                margin-left: 29px;
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                margin-bottom: 12px;

                .label {
                    width: 86px;
                }

                .seal-pic {
                    width: 75px;
                    display: block;
                }
            }

            .sub-layer {
                margin-bottom: 12px;
            }


        }

        .file-check-result+.file-check-result {
            margin-top: 30px;
        }

        .file-check-length {
            font-size: 14px;
            font-weight: 400;
            color: #333;
            margin-bottom: 16px;

            span {
                color: #3296FA;
            }
        }
    }

}
</style>
